export default {
  paged: {
    select:
      'id,year,month,status,currency,budgetAmount,consumedAmount,includedCreditGrantedAmount,includedCreditConsumedAmount,includedCreditAppliedToOtherPeriodsAmount,includedCreditReceivedFromOtherPeriodsAmount,promotionalCreditGrantedAmount,promotionalCreditConsumedAmount,paidCreditGrantedAmount,paidCreditConsumedAmount,billableAmount,periodStart,periodEnd',
    orderBy: 'year desc, month desc',
    searchSelect: [],
  },
};
